import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "question_answer"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner ans" };
const _hoisted_5 = { class: "prof" };
const _hoisted_6 = { class: "ph" };
const _hoisted_7 = { class: "ca_1" };
const _hoisted_8 = { class: "ca_2" };
const _hoisted_9 = { class: "comment" };
const _hoisted_10 = { class: "lock_wrapper" };
const _hoisted_11 = { style: { "white-space": "pre-line" } };
const _hoisted_12 = { class: "date" };
const _hoisted_13 = {
    key: 1,
    style: { "height": "32.39px", "margin": "30px auto" }
};
const _hoisted_14 = { style: { "white-space": "pre-line" } };
const _hoisted_15 = { class: "date" };
const _hoisted_16 = {
    key: 0,
    class: "plus"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "under" };
const _hoisted_19 = { class: "right" };
const _hoisted_20 = {
    key: 0,
    class: "u1 ca1"
};
const _hoisted_21 = {
    key: 1,
    class: "u1 ca3"
};
const _hoisted_22 = {
    key: 2,
    class: "u1 ca2"
};
const _hoisted_23 = { class: "u2" };
const _hoisted_24 = { class: "bread" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
    key: 0,
    class: "alert"
};
const _hoisted_27 = {
    key: 0,
    class: "bt_box"
};
const _hoisted_28 = {
    key: 1,
    class: "bt_box"
};
const _hoisted_29 = { class: "a_lead" };
const _hoisted_30 = { class: "comment_box" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
    key: 0,
    class: "check"
};
const _hoisted_33 = { class: "prof" };
const _hoisted_34 = { class: "prof_ranking" };
const _hoisted_35 = {
    key: 0,
    class: "img_rank"
};
const _hoisted_36 = { class: "heart" };
const _hoisted_37 = ["onClick"];
const _hoisted_38 = { class: "right" };
const _hoisted_39 = { class: "ca_1" };
const _hoisted_40 = { class: "ca_2" };
const _hoisted_41 = {
    class: "name",
    style: { "cursor": "pointer" }
};
const _hoisted_42 = { class: "ph" };
const _hoisted_43 = { class: "w_box" };
const _hoisted_44 = {
    key: 0,
    class: "lock"
};
const _hoisted_45 = {
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_46 = { class: "date" };
const _hoisted_47 = { class: "prof" };
const _hoisted_48 = { class: "prof_ranking" };
const _hoisted_49 = {
    key: 0,
    class: "img_rank"
};
const _hoisted_50 = { class: "heart" };
const _hoisted_51 = ["onMousedown", "onTouchstart"];
const _hoisted_52 = { class: "right" };
const _hoisted_53 = { class: "ca_1" };
const _hoisted_54 = { class: "ca_2" };
const _hoisted_55 = { class: "name" };
const _hoisted_56 = { class: "ph" };
import { ref, watch, computed, onMounted, onUnmounted, onBeforeMount } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-vue3';
import moment from 'moment';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import { AuthRole, QuestionType } from '@util/Consts';
import { isNullOrWhiteSpace } from '@util/Common';
import { tryJsonForObject, getServerTime, isSuccessResponse } from '@util/Common';
import ImageFrame from '@component/ImageFrame.vue';
const showUnreadSecs = 5;
export default /*@__PURE__*/ _defineComponent({
    __name: 'question_answer',
    props: {
        common: {},
        errors: {},
        question: {},
        answers: {}
    },
    setup(__props) {
        var _a, _b, _c;
        const props = __props;
        const isTimeOver = ref();
        // 未読メッセージ最初のID取得
        const unreadId = (_c = (_b = (_a = props.question.additional_questions) === null || _a === void 0 ? void 0 : _a.find(value => !value.is_read && props.question.user.id !== props.common.user_id)) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
        const showUnreadLine = ref(true);
        // 未読の表示時間（秒）
        const content = ref('');
        const showAnswerBtn = ref(false);
        // 通信中か判定
        const processing = ref(false);
        const showAddMessage = computed(() => {
            // 質問者本人で、この質問がロックされていないか判定
            const isSameUser = props.question.user.id === props.common.user_id;
            const isQuestioner = props.common.role === AuthRole.QUESTIONER;
            return !isTimeOver.value && isSameUser && isQuestioner && !props.question.locked && !props.question.ended_at;
        });
        const showQedBtn = computed(() => {
            // 質問者本人で、期限切れで終了していない質問か判定
            const isSameUser = props.question.user.id === props.common.user_id && props.common.role === AuthRole.QUESTIONER;
            const isDeadlinePassedWithNoAnswer = props.question.status == QuestionType.UNDER_EVALUATION && props.answers.length == 0;
            return isTimeOver.value && !props.question.locked && isSameUser && !props.question.ended_at && !isDeadlinePassedWithNoAnswer;
        });
        const setShowAnswer = () => {
            var _a, _b, _c;
            const isMentor = ((_a = props === null || props === void 0 ? void 0 : props.common) === null || _a === void 0 ? void 0 : _a.role) === AuthRole.MENTOR;
            const isQuestioner = props.question.user.id === props.common.user_id;
            // 回答者一覧の中に含まれているか確認
            const isReplied = (_c = (_b = props === null || props === void 0 ? void 0 : props.answers) === null || _b === void 0 ? void 0 : _b.some(value => value.user.id === props.common.user_id)) !== null && _c !== void 0 ? _c : false;
            // 質問者本人でなく、まだ回答していないメンターか判定
            showAnswerBtn.value = (!isTimeOver.value && isMentor && !isReplied && !isQuestioner);
        };
        // 一覧表示する回答のフィルタリング
        const showAnswerList = computed(() => {
            var _a, _b;
            // 相談者本人の場合
            if (props.common.role === AuthRole.QUESTIONER && props.common.user_id === props.question.user.id) {
                return props.answers;
            }
            // 相談に対して回答しているメンターの場合
            if (props.common.role === AuthRole.MENTOR) {
                return (_a = props.answers) === null || _a === void 0 ? void 0 : _a.filter(value => !value.locked || props.common.user_id === value.user.id);
            }
            // 相談に対して回答している管理者の場合
            if (props.common.role === AuthRole.ADMIN) {
                return props.answers;
            }
            // それ以外
            return (_b = props.answers) === null || _b === void 0 ? void 0 : _b.filter(value => !value.locked);
        });
        const showAnswerCount = computed(() => {
            var _a;
            return (_a = props.answers) === null || _a === void 0 ? void 0 : _a.filter(value => !value.locked).length.toLocaleString();
        });
        const getEvaluationRanking = (answer) => {
            return answer.evaluation_ranking !== null && answer.evaluation_ranking !== undefined ? Number(answer.evaluation_ranking) : 0;
        };
        const shouldShowRankImage = (answer) => {
            const ranking = getEvaluationRanking(answer);
            return ranking > 0 && ranking <= 3;
        };
        const getLikeCount = (answer) => {
            return Number(answer.like_count || 0);
        };
        const onSendMessage = computed(() => {
            return isNullOrWhiteSpace(content.value);
        });
        watch(() => content.value, (value) => {
            // 文字数チェック
            if (Alert.charLimitTextArea(value)) {
                content.value = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
            // 編集チェック
            if (0 < value.length) {
                PageExitConfirm.addEvent();
            }
            else {
                PageExitConfirm.removeEvent();
            }
        });
        let sendProcessing = false;
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            const form = InertiaUtil.getForm({ content: content.value });
            const options = { preserveScroll: false, preserveState: (page) => 0 < Object.keys(page.props.errors).length };
            if (sendProcessing)
                return;
            sendProcessing = true;
            InertiaUtil.post(form, route('question.additional', { id: props.question.id }), () => { sendProcessing = false; }, options);
        };
        const onClickClose = () => {
            location.href = route('rank.index', { question_id: props.question.id });
        };
        const onClickAnswer = () => {
            Inertia.get(route('question.answer.create', { question_id: props.question.id }));
        };
        const onClickMentorAnswer = (userId, answerId) => {
            if (showAnswersContent(userId)) {
                Inertia.get(route('question.answer.show', { question_id: props.question.id, answer_id: answerId }));
            }
        };
        const formatRegistered = (date) => {
            return Formatter.formatDate(date, 'YYYY年MM月DD日 HH:mm');
        };
        const formatDeadline = (date) => {
            return Formatter.formatDate(date, 'YYYY年MM月DD日');
        };
        const showAnswersContent = (userId) => {
            if (props.question.ended_at || props.common.role === AuthRole.ADMIN) {
                // 相談が既に終了していれば、誰でも確認可能
                // 管理者の場合は無条件で確認可能
                return true;
            }
            if (props.common.role === AuthRole.QUESTIONER) {
                // 相談者本人であれば、終了前でも確認可能
                // 回答者がメンターモードの場合も確認可能
                return props.question.user.id === props.common.user_id || userId === props.common.user_id;
            }
            else if (props.common.role === AuthRole.MENTOR) {
                // メンターは自身の回答のみ、終了前で確認可能
                return userId === props.common.user_id;
            }
        };
        // いいねイベント
        const onClickHeart = (id) => {
            const answer = props.answers.find(value => value.id === id);
            if (!answer)
                return;
            if (!answer.is_liked) {
                if (processing.value)
                    return;
                processing.value = true;
                // いいねを登録する
                axios.post(route('question.answer.like', { question_id: props.question.id, answer_id: id }))
                    .then(response => {
                    const res = tryJsonForObject(response);
                    if (isSuccessResponse(res.status)) {
                        answer.is_liked = true;
                        answer.like_count = Number(answer.like_count) + 1;
                    }
                    else {
                        location.reload();
                    }
                }).finally(() => { processing.value = false; });
            }
            else {
                // いいねを取り消す
                axios.post(route('question.answer.like', { question_id: props.question.id, answer_id: id }))
                    .then(response => {
                    const res = tryJsonForObject(response);
                    if (isSuccessResponse(res.status)) {
                        answer.is_liked = false;
                        answer.like_count = Number(answer.like_count) - 1;
                    }
                    else {
                        location.reload();
                    }
                });
            }
        };
        // toggle disable for question
        const toggleLock = () => {
            const form = InertiaUtil.getForm({});
            InertiaUtil.post(form, route('question.disable', { id: props.question.id }));
        };
        const closeWindow = () => {
            window.close();
        };
        onBeforeMount(() => {
            getServerTime().then(res => {
                if (res) {
                    // 期限が過ぎているか判定
                    // const dt = moment(new Date(res)).format('YYYY-MM-DD');
                    const dt = moment(new Date()).format('YYYY-MM-DD');
                    const dateFrom = moment(dt);
                    const dateTo = moment(props.question.deadline);
                    isTimeOver.value = dateTo.isBefore(dateFrom);
                    setShowAnswer();
                }
            });
        });
        onMounted(() => {
            // 未読ラインを時間経過で消す
            setTimeout(() => {
                showUnreadLine.value = false;
            }, 1000 * showUnreadSecs);
            axios.post(route('question.read', { id: props.question.id }));
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "close_window",
                                onClick: closeWindow
                            }, _cache[6] || (_cache[6] = [
                                _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                            ])),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(ImageFrame, {
                                            src: props.question.user.photo
                                        }, null, 8, ["src"])
                                    ]),
                                    _createVNode(_unref(Link), {
                                        href: `/user/${props.question.user.id}`
                                    }, {
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString((_a = props.question.user) === null || _a === void 0 ? void 0 : _a.name), 1)
                                            ];
                                        }),
                                        _: 1
                                    }, 8, ["href"]),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString((_a = props.question.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                    _createElementVNode("div", _hoisted_8, _toDisplayString((_b = props.question.question_type) === null || _b === void 0 ? void 0 : _b.name), 1)
                                ]),
                                _createElementVNode("form", null, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass({ lock: (_c = props.question) === null || _c === void 0 ? void 0 : _c.locked })
                                            }, null, 2),
                                            _createElementVNode("dl", null, [
                                                _createElementVNode("dt", null, _toDisplayString(props.question.subject), 1),
                                                _createElementVNode("dd", _hoisted_11, _toDisplayString(props.question.content), 1),
                                                _createElementVNode("dd", _hoisted_12, _toDisplayString(formatRegistered(props.question.created_at)), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.question.additional_questions, (addition, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                        (0 < index && _unref(unreadId) === addition.id && _ctx.question.user.id !== props.common.user_id)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                (showUnreadLine.value)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        class: "unread",
                                                                        onClick: _cache[0] || (_cache[0] = ($event) => (showUnreadLine.value = false))
                                                                    }, _cache[7] || (_cache[7] = [
                                                                        _createElementVNode("span", null, "以下、未読", -1)
                                                                    ])))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_13))
                                                            ], 64))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("dd", _hoisted_14, _toDisplayString(addition.content), 1),
                                                        _createElementVNode("dd", _hoisted_15, _toDisplayString(formatRegistered(addition.created_at)), 1)
                                                    ], 64));
                                                }), 256))
                                            ]),
                                            (showAddMessage.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((content).value = $event)),
                                                        placeholder: "追加入力",
                                                        id: "textarea_1",
                                                        oninput: "resizeTextarea(1,1)"
                                                    }, null, 512), [
                                                        [_vModelText, content.value]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        disabled: onSendMessage.value,
                                                        onClick: _withModifiers(onSubmit, ["prevent"])
                                                    }, "追記", 8, _hoisted_17)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("ul", _hoisted_18, [
                                            _createElementVNode("li", _hoisted_19, [
                                                (props.question.status == _unref(QuestionType).ACCEPTING)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "受付中"))
                                                    : _createCommentVNode("", true),
                                                (props.question.status == _unref(QuestionType).UNDER_EVALUATION)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, "評価中"))
                                                    : _createCommentVNode("", true),
                                                (props.question.status == _unref(QuestionType).ACCEPTED)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "受付済"))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "期限", -1)),
                                                    _createTextVNode(_toDisplayString(formatDeadline(props.question.deadline)), 1)
                                                ])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("ul", _hoisted_24, [
                                                    _createElementVNode("li", null, _toDisplayString((_e = (_d = props.question.job_group) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : 'その他'), 1),
                                                    ((_f = props.question.job) === null || _f === void 0 ? void 0 : _f.name)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, _toDisplayString((_g = props.question.job) === null || _g === void 0 ? void 0 : _g.name), 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ]),
                                        (props.question.locked)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 相談者の投稿は利用規約に違反しているため無効化されました "))
                                            : _createCommentVNode("", true),
                                        (props.common.role === _unref(AuthRole).ADMIN && !props.question.locked)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                href: "#",
                                                class: "breach",
                                                onClick: toggleLock
                                            }, "相談者の違反として全体無効化"))
                                            : _createCommentVNode("", true),
                                        (props.common.role === _unref(AuthRole).ADMIN && props.question.locked)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: "#",
                                                class: "breach",
                                                onClick: toggleLock
                                            }, "無効化を解除する"))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (showQedBtn.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createElementVNode("ul", null, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        id: "submit-button",
                                                        class: "bt_end",
                                                        onClick: onClickClose
                                                    }, " 回答の評価登録 ")
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (showAnswerBtn.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createElementVNode("ul", null, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        id: "submit-button",
                                                        class: "bt_answer",
                                                        onClick: onClickAnswer
                                                    }, " 回答する ")
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(showAnswerCount.value) + "名の回答", 1),
                            _createElementVNode("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAnswerList.value, (answer) => {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (showAnswersContent(answer.user.id))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: answer.id,
                                                onClick: _withModifiers(($event) => (onClickMentorAnswer(answer.user.id, answer.id)), ["stop", "prevent"]),
                                                style: { "cursor": "pointer" },
                                                class: "c_inner"
                                            }, [
                                                (!answer.is_read)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("div", _hoisted_34, [
                                                        (props.question.ended_at)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                (shouldShowRankImage(answer))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                                        _createVNode(ImageFrame, {
                                                                            src: `images/common/i_rank_${getEvaluationRanking(answer)}.svg`
                                                                        }, null, 8, ["src"])
                                                                    ]))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("p", _hoisted_36, [
                                                                    _createElementVNode("i", {
                                                                        class: _normalizeClass([answer.is_liked ? 'fas' : 'far', "fa-heart"]),
                                                                        onClick: _withModifiers(($event) => (onClickHeart(answer.id)), ["stop", "prevent"]),
                                                                        style: { "cursor": "pointer" }
                                                                    }, null, 10, _hoisted_37),
                                                                    _createTextVNode(" " + _toDisplayString(getLikeCount(answer)), 1)
                                                                ])
                                                            ], 64))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("div", _hoisted_39, _toDisplayString((_a = answer.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                                        _createElementVNode("div", _hoisted_40, _toDisplayString((_d = (_c = (_b = answer.user.job_group) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : answer.user.other_job_name) !== null && _d !== void 0 ? _d : 'その他'), 1),
                                                        _createElementVNode("div", _hoisted_41, _toDisplayString((_e = answer.user) === null || _e === void 0 ? void 0 : _e.name), 1),
                                                        _createElementVNode("div", _hoisted_42, [
                                                            _createVNode(ImageFrame, {
                                                                src: answer.user.photo
                                                            }, null, 8, ["src"])
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_43, [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass({ lock_wrapper: answer.locked })
                                                    }, [
                                                        (answer.locked)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[9] || (_cache[9] = [
                                                                _createElementVNode("div", { class: "alert" }, "違反投稿のために無効化されました", -1)
                                                            ])))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(Formatter).formatCharOmit(answer.content, 300)), 1),
                                                        _createElementVNode("div", _hoisted_46, _toDisplayString(formatRegistered(answer.created_at)), 1)
                                                    ], 2)
                                                ])
                                            ], 8, _hoisted_31))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: `hidden-${answer.id}`,
                                                class: "c_inner link_off"
                                            }, [
                                                _createElementVNode("div", _hoisted_47, [
                                                    _createElementVNode("div", _hoisted_48, [
                                                        (shouldShowRankImage(answer))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                                _createVNode(ImageFrame, {
                                                                    src: `images/common/i_rank_${getEvaluationRanking(answer)}.svg`
                                                                }, null, 8, ["src"])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("p", _hoisted_50, [
                                                            _createElementVNode("i", {
                                                                class: _normalizeClass([answer.is_liked ? 'fas' : 'far', "fa-heart"]),
                                                                onMousedown: ($event) => (onClickHeart(answer.id)),
                                                                onMouseup: _cache[2] || (_cache[2] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.onCancelHeartLeave && _ctx.onCancelHeartLeave(...args))),
                                                                onMouseleave: _cache[3] || (_cache[3] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.onCancelHeartLeave && _ctx.onCancelHeartLeave(...args))),
                                                                onTouchstart: ($event) => (onClickHeart(answer.id)),
                                                                onTouchend: _cache[4] || (_cache[4] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.onCancelHeartLeave && _ctx.onCancelHeartLeave(...args))),
                                                                onTouchcancel: _cache[5] || (_cache[5] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.onCancelHeartLeave && _ctx.onCancelHeartLeave(...args))),
                                                                style: { "cursor": "pointer" }
                                                            }, null, 42, _hoisted_51),
                                                            _createTextVNode(_toDisplayString(getLikeCount(answer)), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_52, [
                                                        _createElementVNode("div", _hoisted_53, _toDisplayString((_f = answer.user.industry) === null || _f === void 0 ? void 0 : _f.name), 1),
                                                        _createElementVNode("div", _hoisted_54, _toDisplayString((_h = (_g = answer.user.job_group) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : 'その他'), 1),
                                                        _createElementVNode("div", _hoisted_55, _toDisplayString((_j = answer.user) === null || _j === void 0 ? void 0 : _j.name), 1),
                                                        _createElementVNode("div", _hoisted_56, [
                                                            _createVNode(ImageFrame, {
                                                                src: (_k = answer.user) === null || _k === void 0 ? void 0 : _k.photo
                                                            }, null, 8, ["src"])
                                                        ])
                                                    ])
                                                ]),
                                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w_box no_end" }, [
                                                    _createElementVNode("p", null, "（相談が終了するまでの間非表示です）")
                                                ], -1))
                                            ]))
                                    ], 64));
                                }), 256))
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
